import moment from 'moment';

const genericMessage = 'That code didn\'t work. Try again?';
const errorMessages  = {
  '1': 'We don\'t recognize that code. Try again?',
  '2': 'Your address isn\'t eligible for that code.',
  '3': 'That code isn\'t active yet. Try again soon!',
  '4': 'Aw, shoot. That code is expired.',
  '5': 'Aw, shoot. That code is no longer valid.',
  'promo_less_favorable':
    'The existing promo was better than that code, so we skipped it.',
  'plan_not_eligible':
    'The internet plan you have selected is not eligible for this promotion.'
};

const codeToTag = {
  '1': 'not_found',
  '2': 'address_not_eligible',
  '3': 'not_yet_active',
  '4': 'expired',
  '5': 'max_redemptions_exceeded'
};

const numsMap = {
  '1': 'one',
  '2': 'two',
  '3': 'three',
  '4': 'four',
  '5': 'five',
  '6': 'six',
  '7': 'seven',
  '8': 'eight',
  '9': 'nine',
  '10': 'ten',
  '11': 'eleven',
  '12': 'twelve'
};

const formatTrial = ( period ) => {
  const remainder = ( period % 30 );
  let unit      = remainder ? 'day' : 'month';
  const duration  = remainder ? period : ( period / 30 );

  if ( duration !== 1 ) {
    unit += 's';
  }

  return {
    duration,
    unit,
    str: `${ numsMap[ duration ] || duration } ${ unit }`
  };
};

const getBillingStart = ( installDate, trialDuration ) => {
  const install = moment( installDate );
  return install.add( trialDuration, 'days' );
};

export {
  formatTrial,
  getBillingStart
};

export default {

  getErrorMsg( code ) {
    return errorMessages[ code ] || genericMessage;
  },

  getErrorTag( code ) {
    return codeToTag[ code ] || 'unknown_error';
  },

  getDuration( ...durations ) {
    return Math.max( ...durations );
  }

};
